import { Service, service, inject } from './di'
import { ConfigService } from './ConfigService'
import { SeoService } from './SeoService'
import { fetchJSON } from '../utils/fetch'
import { https } from '../utils/http'
import { SearchJSON, MultiEcomItemJSON } from '../definitions/ApiDefinitions'

@service('gateflippService')
export class Gateflipp extends Service {
    @inject config: ConfigService
    @inject seoService: SeoService

    private get _locale() {
        // Work around backflipp only accepting fr-CA for French.
        const locale = this.seoService.locale || 'en'
        return locale === 'fr' ? 'fr-CA' : locale
    }

    getMultiEcomItems(globalIds: string[]): Promise<MultiEcomItemJSON> {
        return fetchJSON(
            `${this.config.ECOM_ITEMS_SERVER}?global_ids=${globalIds.join(',')}`
        ).then((json: MultiEcomItemJSON) => {
            if (!json || (<any>json).error) {
                return null
            }

            return json
        })
    }

    search(postalCode: string, query: string): Promise<SearchJSON> {
        const distType = this.getDistTypeAppendix()

        return fetchJSON<SearchJSON>(
            `${this.config.SEARCH_SERVER}?locale=${this._locale}&postal_code=${postalCode}&sid=&q=${encodeURIComponent(query)}${distType}`,
            null,
            10
        ).then((json: SearchJSON) => {
            json.items.forEach((item) => {
                if (
                    item.merchant_image_url &&
                    item.merchant_image_url !== '/images/bg/logo_bg.gif'
                )
                    item.merchant_image_url = https(item.merchant_image_url)
                else delete item.merchant_image_url
                item.clipping_image_url = https(item.clipping_image_url)
            })

            if (Array.isArray(json.ecom_items) && json.ecom_items.length > 0) {
                json.ecom_items.forEach((ecomItemObj) => {
                    ecomItemObj.merchant_logo = https(ecomItemObj.merchant_logo)
                    ecomItemObj.image_url = https(ecomItemObj.image_url)
                })
            }

            return json
        })
    }

    private getDistTypeAppendix() {
        return this.config.aidHero ? '&channel=dist' : ''
    }
}
